import { Module } from "vuex";
import { RootState } from "../index";
import { getApplications, createApplication } from "@/shared/api/applications";
import { ElMessage } from "element-plus";
import { IApplication } from "@/shared/types/applications";

export interface IState {
  list: IApplication[];
}

const applicationsModule: Module<IState, RootState> = {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    SET_LIST(state, list) {
      state.list = list;
    },
    ADD_ITEM_TO_LIST(state, item) {
      state.list.push(item);
    },
  },
  actions: {
    async getApplications({ commit }) {
      try {
        const response = await getApplications();
        if (response && response.code === 200 && response.data) {
          commit("SET_LIST", response.data);
          return response;
        } else {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
    async createApplication(
      { commit },
      payload: { title: string; bundle: string }
    ) {
      try {
        const response = await createApplication(payload);
        if (response && response.code === 200 && response.data) {
          commit("ADD_ITEM_TO_LIST", response.data);
          return response;
        } else {
          throw response.message;
        }
      } catch (e: any) {
        ElMessage({
          message: e,
          type: "error",
        });
      }
    },
  },
};

export default applicationsModule;
